module.exports = __webpack_public_path__ + "static/img/lenovoYOGATab5.61666d13.png";